<p-toast></p-toast>

<p-dialog [(visible)]="displayConfirmDialog"
          [modal]="true"
          [style]="{ width: '40vw' }"
          [draggable]="false"
          [resizable]="false"
          [closable]="true">
    <ng-template pTemplate="item">
        <div class="modal-content-center">
            <h1>{{ isRoleExist ? "Update Permissions?" : "Create New Role?" }}</h1>
        </div>
        <div class="modal-content-center">
            <p>
                {{ isRoleExist ? "Are you sure you want to update “Permissions”?" : "Are you sure you want to create new role?" }}
            </p>
            <br/>
        </div>
        <div class="modal-buttons-container">
            <button pButton
                    icon="pi pi-check"
                    class="p-element btn-darkblue p-button p-component mr-1"
                    label="Confirm"
                    (click)="confirmAction()"></button>
            <button pButton
                    icon="pi pi-times"
                    label="Cancel"
                    class="p-element btn-cancel p-button p-component"
                    (click)="changeConfirmDialogVisibility()"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<p-sidebar [(visible)]="visibleRolesDetail"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'900px'}">
    <ng-template pTemplate="header">{{ isRoleExist ? 'Role: ' + selectedRole?.Name : "Create Role" }}</ng-template>

    <div class="bg-menu" *ngIf="mItems">
        <p-tabMenu [model]="mItems" [scrollable]="true" [activeItem]="mItems[0]"></p-tabMenu>
    </div>

    <div class="driver-body">
        <div *ngIf="activeTab === menuTab.Privileges">

            <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                           [styleClass]="'app-scrollpanel'">
                <form #roleForm="ngForm">
                    <div class="flex flex-row pb-3 align-items-center">
                        <div class="col-6 p-2">
                            <div class="new-diciplinary-label">Role Name</div>
                            <input type="text"
                                   [(ngModel)]="selectedRole.Name"
                                   name="roleName" required
                                   placeholder="Enter Name"
                                   pInputText />
                        </div>
                        <div class="col-6 p-2 text-right">
                            <button pButton
                                    icon="pi pi-check"
                                    class="p-element btn-darkblue p-button p-component"
                                    label="Save"
                                    (click)="showConfirmDialog()"
                                    [disabled]="!roleForm.valid"></button>
                        </div>
                    </div>
                </form>

                <p-treeTable [value]="permissions" [scrollable]="true" [tableStyle]="{'min-width':'50rem'}"
                             [style]="{height: '100%'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 45%;">Privileges</th>
                            <th>Read</th>
                            <th>Create</th>
                            <th>Delete</th>
                            <th>Update</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                        <tr [ttRow]="rowNode">
                            <td style="width: 45%;">
                                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                {{ rowData.Name }}
                            </td>
                            <td>
                                <p-checkbox [binary]="true" [(ngModel)]="rowData.CanRead"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [binary]="true" [(ngModel)]="rowData.CanCreate"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [binary]="true" [(ngModel)]="rowData.CanDelete"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [binary]="true" [(ngModel)]="rowData.CanUpdate"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-treeTable>
            </p-scrollPanel>
        </div>

        <div *ngIf="activeTab === menuTab.AllUsers">
            <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                           [styleClass]="'app-scrollpanel'">
                <div *ngFor="let item of users">
                    <div class="lm-active-order-details-main-block">
                        <div class="flex flex-row">
                            <div style="margin-right: 30px;" class="driver-info-img">
                                <img style="border: 2px solid #004060" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                            </div>
                            <div class="ml-3">
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Id:</div>
                                    <div class="lm-active-order-details-field-value">{{item.Id}}</div>
                                </div>
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Name:</div>
                                    <div class="lm-active-order-details-field-value">
                                        <span class="lm-active-order-link">{{item.UserName}}</span>
                                    </div>
                                </div>
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Email:</div>
                                    <div class="lm-active-order-details-field-value">{{item.Email}}</div>
                                </div>
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Created:</div>
                                    <div class="lm-active-order-details-field-value"> {{item.CreatedAt}}</div>
                                </div>
                                <div class="lm-active-order-details-field-block">
                                    <div class="lm-active-order-details-field-name">Last Active:</div>
                                    <div class="lm-active-order-details-field-value">
                                        <span class="lm-active-order-link">{{item.LastActive}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </p-scrollPanel>
        </div>
    </div>
</p-sidebar>
